import { CurrencyIsoCode } from 'shared/data/wallets/v1';
import { z } from 'zod';

import { FileFormat, ReportPeriod } from './BankStatementReportPopupContent.types';

export const schema = z.object({
    period: z.nativeEnum(ReportPeriod),
    dateFrom: z.date().nullish(),
    dateTo: z.date().nullish(),
    currency: z.nativeEnum(CurrencyIsoCode).nullish(),
    format: z.nativeEnum(FileFormat),
});
